/* eslint-disable */
/* This file is auto-generated. Do not edit this file directly. */

/*
 * This file contains an index of all the routes in the app. It can help to
 * catch broken links at build time. If a route is moved or removed, any
 * references to its original key in this file will raise an error.
 */

export const pages = {
  NotFoundPage: '*',
  RootPage: '/',
  AppLogin: '/app-login',
  NetworkRootPage: '/network/:networkUUID',
  CompanyRootPage: '/org/:companyName',
  AutoVPNPage: '/org/:companyName/auto-vpn',
  AutoVPNGroupsPage: '/org/:companyName/auto-vpn/groups',
  AutoVPNGroupPage: '/org/:companyName/auto-vpn/groups/:groupUUID/:activeTab',
  CommandPage: '/org/:companyName/command',
  ConnectPage: '/org/:companyName/connect',
  ConnectDashboardAllLocationsPage: '/org/:companyName/connect/locations',
  ConnectDashboardLocationPage: '/org/:companyName/connect/locations/:companyLocationSID',
  GuestPage: '/org/:companyName/guest',
  HubPage: '/org/:companyName/hub/:tab',
  HubCardsPage: '/org/:companyName/hub/cards',
  HubListPage: '/org/:companyName/hub/list',
  HubMapPage: '/org/:companyName/hub/map',
  IndividualNetworkRootPage: '/org/:companyName/network/:networkSlug',
  DeviceConfigHistoryVersionPage: '/org/:companyName/network/:networkSlug/config/:serialNumber/history/compare',
  DesignPage: '/org/:companyName/network/:networkSlug/design',
  FloorPlansPage: '/org/:companyName/network/:networkSlug/design/floor-plans',
  FloorPlanPage: '/org/:companyName/network/:networkSlug/design/floor-plans/:floorPlanUUID',
  RackElevationsPage: '/org/:companyName/network/:networkSlug/design/rack-elevations',
  HardwarePage: '/org/:companyName/network/:networkSlug/hardware/:tab',
  AccessPointsPage: '/org/:companyName/network/:networkSlug/hardware/access-points',
  AccessPointsListPage: '/org/:companyName/network/:networkSlug/hardware/access-points/:tab',
  AccessPointPage: '/org/:companyName/network/:networkSlug/hardware/access-points/:uuid/:tab',
  AccessPointsListACSJobPage: '/org/:companyName/network/:networkSlug/hardware/access-points/acs/:job',
  ObserversPage: '/org/:companyName/network/:networkSlug/hardware/observers',
  ObserverPage: '/org/:companyName/network/:networkSlug/hardware/observers/:uuid/:tab',
  ObserversListPage: '/org/:companyName/network/:networkSlug/hardware/observers/list',
  ObserversTargetsPage: '/org/:companyName/network/:networkSlug/hardware/observers/targets',
  ObserversTestsPage: '/org/:companyName/network/:networkSlug/hardware/observers/tests',
  PowerDistributionUnitListPage: '/org/:companyName/network/:networkSlug/hardware/power-distribution-units/:tab',
  PowerDistributionUnitDetailPage: '/org/:companyName/network/:networkSlug/hardware/power-distribution-units/:uuid/:tab',
  SecurityAppliancesListPage: '/org/:companyName/network/:networkSlug/hardware/security-appliances/:tab',
  SecurityAppliancePage: '/org/:companyName/network/:networkSlug/hardware/security-appliances/:uuid/:tab',
  SwitchesPage: '/org/:companyName/network/:networkSlug/hardware/switches/:tab',
  SwitchDetailPage: '/org/:companyName/network/:networkSlug/hardware/switches/:uuid/:tab',
  InsightsPage: '/org/:companyName/network/:networkSlug/insights',
  ClientsListPage: '/org/:companyName/network/:networkSlug/insights/clients',
  ClientPage: '/org/:companyName/network/:networkSlug/insights/clients/:macAddress/:tab',
  ClientVulnerabilitiesPage: '/org/:companyName/network/:networkSlug/insights/clients/:macAddress/vulnerabilities/:subtab',
  ClientsBlockedPage: '/org/:companyName/network/:networkSlug/insights/clients/blocked',
  ClientsConnectionEventsPage: '/org/:companyName/network/:networkSlug/insights/clients/connection-events',
  ClientsVulnerabilitiesCPEsPage: '/org/:companyName/network/:networkSlug/insights/clients/vulnerabilities/cpes',
  ClientsVulnerabilitiesCVEsPage: '/org/:companyName/network/:networkSlug/insights/clients/vulnerabilities/cves',
  HostMonitoringPage: '/org/:companyName/network/:networkSlug/insights/host-monitoring',
  EventLogPage: '/org/:companyName/network/:networkSlug/insights/logs',
  AnomaliesListPage: '/org/:companyName/network/:networkSlug/insights/logs/anomalies',
  MutationsDiffAuditLogPage: '/org/:companyName/network/:networkSlug/insights/logs/audit-log',
  NetworkMutationsListPage: '/org/:companyName/network/:networkSlug/insights/logs/mutations',
  StatsListPage: '/org/:companyName/network/:networkSlug/insights/logs/stats',
  InsightsNetworkPage: '/org/:companyName/network/:networkSlug/insights/network',
  TopologyPage: '/org/:companyName/network/:networkSlug/insights/topology',
  InstallStatusPage: '/org/:companyName/network/:networkSlug/install-status',
  NetworkTabletJoinInstructionsPage: '/org/:companyName/network/:networkSlug/join/:ssid',
  NetworkWidePage: '/org/:companyName/network/:networkSlug/network-wide',
  CaptivePortalsPage: '/org/:companyName/network/:networkSlug/network-wide/captive-portals',
  CaptivePortalPage: '/org/:companyName/network/:networkSlug/network-wide/captive-portals/:uuid/:tab',
  CaptivePortalAddPage: '/org/:companyName/network/:networkSlug/network-wide/captive-portals/add',
  ISPsPage: '/org/:companyName/network/:networkSlug/network-wide/isps',
  ISPPage: '/org/:companyName/network/:networkSlug/network-wide/isps/:isp',
  ISPInsightsPage: '/org/:companyName/network/:networkSlug/network-wide/isps/:uuid/insights',
  RADIUSProfilesPage: '/org/:companyName/network/:networkSlug/network-wide/radius-profiles',
  RateLimitingPage: '/org/:companyName/network/:networkSlug/network-wide/rate-limiting',
  RoutingPage: '/org/:companyName/network/:networkSlug/network-wide/routing/:tab',
  VLANListPage: '/org/:companyName/network/:networkSlug/network-wide/vlans',
  VLANPage: '/org/:companyName/network/:networkSlug/network-wide/vlans/:uuid/:tab',
  IndividualNetworkOnboardingPage: '/org/:companyName/network/:networkSlug/onboarding',
  OperatorsPage: '/org/:companyName/network/:networkSlug/operators',
  DeviceConfigHistoryPage: '/org/:companyName/network/:networkSlug/operators/config/:serialNumber/history',
  DeviceConfigOverridesPage: '/org/:companyName/network/:networkSlug/operators/config/:serialNumber/overrides',
  NetworkUpgradesPage: '/org/:companyName/network/:networkSlug/operators/nos-upgrades/:tab',
  OutletTopologyLayoutPage: '/org/:companyName/network/:networkSlug/outlet-topology-layout',
  PatchPanelLayoutPage: '/org/:companyName/network/:networkSlug/patch-panel-layout',
  SecureTunnelsPage: '/org/:companyName/network/:networkSlug/secure-tunnels',
  IPSecTunnelsPage: '/org/:companyName/network/:networkSlug/secure-tunnels/ipsec',
  IPSecTunnelPage: '/org/:companyName/network/:networkSlug/secure-tunnels/ipsec/:ipSecTunnelUUID',
  ClientVPNPage: '/org/:companyName/network/:networkSlug/secure-tunnels/vpn',
  SecurityPage: '/org/:companyName/network/:networkSlug/security',
  DNSSecurityPage: '/org/:companyName/network/:networkSlug/security/dns-security',
  FirewallPage: '/org/:companyName/network/:networkSlug/security/firewall',
  ApplicationRulesPage: '/org/:companyName/network/:networkSlug/security/firewall/application',
  MulticastPage: '/org/:companyName/network/:networkSlug/security/multicast',
  NIDSPage: '/org/:companyName/network/:networkSlug/security/nids/:tab',
  OneToOneNATPage: '/org/:companyName/network/:networkSlug/security/one-to-one-nat',
  PortForwardingPage: '/org/:companyName/network/:networkSlug/security/port-forwarding',
  ToolsPage: '/org/:companyName/network/:networkSlug/tools',
  PacketCaptureAPPage: '/org/:companyName/network/:networkSlug/tools/packet-capture-ap/',
  PacketCaptureObserverPage: '/org/:companyName/network/:networkSlug/tools/packet-capture-observer/',
  PingTestPage: '/org/:companyName/network/:networkSlug/tools/ping-test/:ispName',
  SpeedTestPage: '/org/:companyName/network/:networkSlug/tools/speed-test/:ispName',
  SpeedTestHistoricalResultsPage: '/org/:companyName/network/:networkSlug/tools/speed-test/results/:uuid',
  WirelessPage: '/org/:companyName/network/:networkSlug/wireless',
  Hotspot20sPage: '/org/:companyName/network/:networkSlug/wireless/hotspot2.0',
  RadioProfilesPage: '/org/:companyName/network/:networkSlug/wireless/radio-profiles',
  SSIDsPage: '/org/:companyName/network/:networkSlug/wireless/ssids',
  SSIDPage: '/org/:companyName/network/:networkSlug/wireless/ssids/:uuid/:tab',
  WIDSPage: '/org/:companyName/network/:networkSlug/wireless/wids/:tab',
  AllowlistPage: '/org/:companyName/network/:networkSlug/wireless/wids/allowlist',
  HoneypotSSIDsPage: '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids',
  HoneypotSSIDPage: '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids/:honeypotSSID',
  HoneypotSSIDBroadcasterPage: '/org/:companyName/network/:networkSlug/wireless/wids/honeypot-ssids/:honeypotSSID/:bssid',
  RogueAPsPage: '/org/:companyName/network/:networkSlug/wireless/wids/rogue-aps',
  OrgOnboardingPage: '/org/:companyName/onboarding',
  NetworkOnboardingPage: '/org/:companyName/onboarding/network/:networkSlug',
  SettingsPage: '/org/:companyName/settings',
  SettingsOrgPage: '/org/:companyName/settings/org',
  SettingsOrgNetworksPage: '/org/:companyName/settings/org/:networkSlug/networks',
  SettingsOrgNotificationsPage: '/org/:companyName/settings/org/:networkSlug/notifications/:tab',
  SettingsOrgServiceDiscoveryPage: '/org/:companyName/settings/org/:networkSlug/service-discovery',
  SettingsOrgAccountPage: '/org/:companyName/settings/org/account',
  SettingsOrgAuthenticationPage: '/org/:companyName/settings/org/authentication',
  SettingsOrgDocumentsPage: '/org/:companyName/settings/org/documents',
  SettingsOrgIntegrationsPage: '/org/:companyName/settings/org/integrations/:tab',
  SettingsOrgUsersPage: '/org/:companyName/settings/org/users',
  SettingsUserPage: '/org/:companyName/settings/user',
  SettingsUserPreferencesPage: '/org/:companyName/settings/user/preferences',
  SupportPage: '/org/:companyName/support',
  ToolshedPage: '/toolshed',
  CLIPage: '/toolshed/cli/:uuid',
  CompanyListPage: '/toolshed/companies',
  CompanyNetworkListPage: '/toolshed/companies/:slug/networks',
  CompanyUsersPage: '/toolshed/companies/:slug/users',
  AddFirmwareBulkUpgradePage: '/toolshed/firmware-bulk-upgrader/add',
  FirmwareUpgradeGroupList: '/toolshed/firmware-bulk-upgrader/upgrade-groups',
  FirmwareBulkUpgradesListPage: '/toolshed/firmware-bulk-upgrader/upgrades',
  ShowFleetwideAlertPage: '/toolshed/fleetwide-alert-management/:fleetwideAlertUUID',
  FleetwideAlertManagementPage: '/toolshed/fleetwide-alert-management/alerts',
  FleetwideAlertSnoozesPage: '/toolshed/fleetwide-alert-management/snoozes',
  NOSPage: '/toolshed/nos-config/:tab',
  PromosPage: '/toolshed/promos',
  ProvidersListPage: '/toolshed/providers',
  ProviderStaticRatesListPage: '/toolshed/providers/:providerUUID/static-rates',
  OperatorSecurityApplianceListPage: '/toolshed/security-appliances',
  VirtualDeviceRootPage: '/virtual-device/:virtualDeviceUUID',
} as const;